module.exports = __webpack_public_path__ + "static/media/realtalk_sd_links_deactive7f5ca5da101175118448f28e0b79804d.webp";